import classNames from 'classnames';
import { ContentBoxHeading } from 'app/agriculture/components/ContentBox/components/ContentBoxHeading';
import './RoundedContentSection.scss';

interface RoundedContentSectionProps {
    className?: string;
    children?: React.ReactNode;
    heading?: string;
}

function RoundedContentSection({ className, heading, children }: RoundedContentSectionProps) {
    return (
        <div className={classNames(className, 'RoundedContentSection')}>
            {!heading ? null : <ContentBoxHeading text={heading} />}
            <div className="RoundedContentSection__section">{children}</div>
        </div>
    );
}

export { RoundedContentSection };
